module.exports = __webpack_public_path__ + "b1827cd46acd0f02d51bc01e8fe227ad.pdf";